<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <g>
            <path d="M44.1,5.8H5.9c-1.9,0-3.5,1.6-3.5,3.5v6.3c0,1.9,1.6,3.5,3.5,3.5h38.2c1.9,0,3.5-1.6,3.5-3.5v-6.3c0-1.9-1.6-3.5-3.5-3.5ZM5.4,15.7v-6.3c0-.3.2-.5.5-.5h17.6v7.4H5.9c-.3,0-.5-.2-.5-.5ZM44.6,15.7c0,.3-.2.5-.5.5h-17.6v-7.4h17.6c.3,0,.5.2.5.5v6.3Z"/>
            <path d="M44.1,30.8H5.9c-1.9,0-3.5,1.6-3.5,3.5v6.3c0,1.9,1.6,3.5,3.5,3.5h38.2c1.9,0,3.5-1.6,3.5-3.5v-6.3c0-1.9-1.6-3.5-3.5-3.5ZM5.4,40.7v-6.3c0-.3.2-.5.5-.5h17.6v7.4H5.9c-.3,0-.5-.2-.5-.5ZM44.6,40.7c0,.3-.2.5-.5.5h-17.6v-7.4h17.6c.3,0,.5.2.5.5v6.3Z"/>
        </g>
        <path d="M27.1,25l2.1-2.1c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0l-2.1,2.1-2.1-2.1c-.6-.6-1.5-.6-2.1,0s-.6,1.5,0,2.1l2.1,2.1-2.1,2.1c-.6.6-.6,1.5,0,2.1s.7.4,1.1.4.8-.1,1.1-.4l2.1-2.1,2.1,2.1c.3.3.7.4,1.1.4s.8-.1,1.1-.4c.6-.6.6-1.5,0-2.1l-2.1-2.1Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>